/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Navbar from "react-bootstrap/Navbar";

import { useIsAuthenticated } from "@azure/msal-react";
import { ProfileSection } from './ProfileSection.jsx'
import { SignInButton } from "./SignInButton.jsx";
import logo from '../logo.svg';
import "../styles/navbar.css";

export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();


    if (window.location.pathname === '/')
        localStorage.removeItem("user");

    return (
        <>
            <Navbar bg="light" variant="light" className="navbar-style">
                <a className="navbar-brand" href="/">
                    <img src={logo} alt="logo" height={50} width={70} />
                </a>
                <h4>Reuse Optimisation Board</h4>
                <div className="collapse navbar-collapse justify-content-end">
                    {isAuthenticated ? <ProfileSection /> : <SignInButton />}
                </div>
            </Navbar>
            {props.children}
        </>
    );
};